export default __webpack_public_path__ + "static/media/Boots of the Kozak Slayer.4bbab25b.jpg";